import { Vector2 } from "../../maths/Vector2";
const minAngle = 15 * Math.PI / 180;
const precision = 1e-13;
const tempData = new Array(256);
const vec2 = new Vector2();
export class BasePoly {
    static createLine2(p, indices, lineWidth, indexBase, outVertex, loop) {
        if (p.length < 4)
            return null;
        let offset = indexBase;
        var points = tempData.length > (p.length + 2) ? tempData : new Array(p.length + 2);
        points[0] = p[0];
        points[1] = p[1];
        var newlen = 2;
        var i = 0;
        var length = p.length;
        for (i = 2; i < length; i += 2) {
            if (Math.abs(p[i] - p[i - 2]) + Math.abs(p[i + 1] - p[i - 1]) > 0.01) {
                points[newlen++] = p[i];
                points[newlen++] = p[i + 1];
            }
        }
        let delta = Math.abs(p[0] - points[newlen - 2]) + Math.abs(p[1] - points[newlen - 1]);
        if (loop && delta > 0) {
            if (delta > precision) {
                points[newlen++] = p[0];
                points[newlen++] = p[1];
            }
            else {
                points[newlen - 2] = p[0];
                points[newlen - 1] = p[1];
            }
        }
        var result = outVertex;
        let startIndex = result.length;
        length = newlen / 2;
        var w = lineWidth / 2;
        let x1 = points[0];
        let y1 = points[1];
        let x2 = points[2];
        let y2 = points[3];
        let x3, y3;
        this.getNormal(x1, y1, x2, y2, w, vec2);
        result.push(x1 - vec2.x, y1 - vec2.y, x1 + vec2.x, y1 + vec2.y);
        let verIndex = [];
        let cVerIndex = 0;
        for (i = 1; i < length - 1; i++) {
            x1 = points[(i - 1) * 2];
            y1 = points[(i - 1) * 2 + 1];
            x2 = points[(i) * 2];
            y2 = points[(i) * 2 + 1];
            x3 = points[(i + 1) * 2];
            y3 = points[(i + 1) * 2 + 1];
            cVerIndex = this._setMiddleVertexs(x1, y1, x2, y2, x3, y3, w, result, vec2, verIndex, cVerIndex);
        }
        x1 = points[newlen - 4];
        y1 = points[newlen - 3];
        x2 = points[newlen - 2];
        y2 = points[newlen - 1];
        if (x2 == points[0] && y2 == points[1]) {
            x3 = points[2];
            y3 = points[3];
            cVerIndex = this._setMiddleVertexs(x1, y1, x2, y2, x3, y3, w, result, vec2, verIndex, cVerIndex);
            let len = result.length;
            result[startIndex] = result[len - 4];
            result[startIndex + 1] = result[len - 3];
            result[startIndex + 2] = result[len - 2];
            result[startIndex + 3] = result[len - 1];
            verIndex.push(cVerIndex, cVerIndex + 1, 1, cVerIndex + 1, 1, 0);
        }
        else {
            this.getNormal(x1, y1, x2, y2, w, vec2);
            result.push(x2 - vec2.x, y2 - vec2.y, x2 + vec2.x, y2 + vec2.y);
            verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2, cVerIndex + 1, cVerIndex + 2, cVerIndex + 3);
        }
        for (let i = 0, len = verIndex.length; i < len; i++) {
            const pIndex = verIndex[i] + offset;
            indices.push(pIndex);
        }
        return result;
    }
    static _setMiddleVertexs(x1, y1, x2, y2, x3, y3, w, vertexs, out, verIndex, cVerIndex) {
        this.getNormal(x1, y1, x2, y2, w, out);
        let pl1x = x1 - out.x;
        let pl1y = y1 - out.y;
        let pl2x = x2 - out.x;
        let pl2y = y2 - out.y;
        let pr1x = x1 + out.x;
        let pr1y = y1 + out.y;
        let pr2x = x2 + out.x;
        let pr2y = y2 + out.y;
        this.getNormal(x2, y2, x3, y3, w, out);
        let pl3x = x2 - out.x;
        let pl3y = y2 - out.y;
        let pl4x = x3 - out.x;
        let pl4y = y3 - out.y;
        let pr3x = x2 + out.x;
        let pr3y = y2 + out.y;
        let pr4x = x3 + out.x;
        let pr4y = y3 + out.y;
        let addCount = 1;
        let count = BasePoly.checkCrossPoint(pl1x, pl1y, pl2x, pl2y, pl3x, pl3y, pl4x, pl4y, vertexs, pr1x, pr1y, pr4x, pr4y, x2, y2, w);
        if (false === count) {
            return this._createSimpleLineVertices(x1, y1, x2, y2, x3, y3, vertexs, verIndex, cVerIndex, pr2x, pr2y, pl2x, pl2y);
        }
        else {
            addCount = BasePoly.checkCrossPoint(pr1x, pr1y, pr2x, pr2y, pr3x, pr3y, pr4x, pr4y, vertexs, pl1x, pl1y, pl4x, pl4y, x2, y2, w);
            if (false === addCount) {
                vertexs.splice(vertexs.length - count * 2, count * 2);
                return this._createSimpleLineVertices(x1, y1, x2, y2, x3, y3, vertexs, verIndex, cVerIndex, pr2x, pr2y, pl2x, pl2y);
            }
        }
        if (2 === addCount) {
            this._setTurnPoint(vertexs, 2);
            verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 3, cVerIndex + 1, cVerIndex + 3, cVerIndex + 2);
            cVerIndex += 2;
            verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2);
            cVerIndex += 1;
        }
        else {
            if (2 === count) {
                verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2, cVerIndex + 1, cVerIndex + 2, cVerIndex + 4);
                cVerIndex += 2;
                verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2);
                cVerIndex += 1;
            }
            else {
                verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2, cVerIndex + 1, cVerIndex + 2, cVerIndex + 3);
                cVerIndex += 2;
            }
        }
        return cVerIndex;
    }
    static angleBetweenPoints(x1, y1, x2, y2, x3, y3) {
        const v1x = x1 - x2;
        const v1y = y1 - y2;
        const v2x = x3 - x2;
        const v2y = y3 - y2;
        const dot = v1x * v2x + v1y * v2y;
        const len1 = Math.hypot(v1x, v1y);
        const len2 = Math.hypot(v2x, v2y);
        if (len1 === 0 || len2 === 0)
            return 0;
        let cosTheta = dot / (len1 * len2);
        cosTheta = Math.min(1, Math.max(-1, cosTheta));
        return Math.acos(cosTheta);
    }
    static _createSimpleLineVertices(x1, y1, x2, y2, x3, y3, vertexs, verIndex, cVerIndex, pr2x, pr2y, pl2x, pl2y) {
        let angle = this.angleBetweenPoints(x1, y1, x2, y2, x3, y3);
        if (angle > Math.PI / 2) {
            vertexs.push(pl2x, pl2y, pr2x, pr2y);
            verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 2, cVerIndex + 1, cVerIndex + 2, cVerIndex + 3);
            cVerIndex += 2;
            return cVerIndex;
        }
        vertexs.push(pr2x, pr2y, pl2x, pl2y);
        verIndex.push(cVerIndex, cVerIndex + 1, cVerIndex + 3, cVerIndex + 1, cVerIndex + 3, cVerIndex + 2);
        cVerIndex += 2;
        return cVerIndex;
    }
    static _setTurnPoint(vertexs, position = 0) {
        let p3x = vertexs[vertexs.length - 2 - position];
        let p3y = vertexs[vertexs.length - 1 - position];
        let p4x = vertexs[vertexs.length - 4 - position];
        let p4y = vertexs[vertexs.length - 3 - position];
        vertexs[vertexs.length - 2 - position] = p4x;
        vertexs[vertexs.length - 1 - position] = p4y;
        vertexs[vertexs.length - 4 - position] = p3x;
        vertexs[vertexs.length - 3 - position] = p3y;
    }
    static checkCrossPoint(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y, vertexs, pp1x, pp1y, pp4x, pp4y, cpx, cpy, wnum) {
        const crossPoint = this.getCrossPoint(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y, true);
        if (crossPoint) {
            vertexs.push(crossPoint.x, crossPoint.y);
            return 1;
        }
        else if (false === crossPoint) {
            return false;
        }
        const crossPoint1 = this.getCrossPoint(pp1x, pp1y, p1x, p1y, p3x, p3y, p4x, p4y, true);
        if (crossPoint1) {
            return false;
        }
        else {
            const crossPoint2 = this.getCrossPoint(p1x, p1y, p2x, p2y, p4x, p4y, pp4x, pp4y, true);
            if (crossPoint2) {
                return false;
            }
        }
        const crossPoint3 = this.getCrossPoint(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y);
        if (crossPoint3) {
            const d = Math.abs(this.getDistance(cpx, cpy, crossPoint3.x, crossPoint3.y));
            const maxNum = wnum * 1.5;
            if (d > maxNum) {
                vertexs.push(p2x, p2y);
                vertexs.push(p3x, p3y);
                return 2;
            }
            vertexs.push(crossPoint3.x, crossPoint3.y);
            return 1;
        }
        return false;
    }
    static getCrossPoint(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y, isLineSegment = false) {
        const dx1 = p2x - p1x;
        const dy1 = p2y - p1y;
        const dx2 = p4x - p3x;
        const dy2 = p4y - p3y;
        const denominator = dx1 * dy2 - dx2 * dy1;
        if (Math.abs(denominator) < 1e-10) {
            return false;
        }
        const t1 = ((p3x - p1x) * dy2 - (p3y - p1y) * dx2) / denominator;
        const t2 = ((p3x - p1x) * dy1 - (p3y - p1y) * dx1) / denominator;
        if (isLineSegment) {
            if (t1 < 0 || t1 > 1) {
                return null;
            }
            if (t2 < 0 || t2 > 1) {
                return null;
            }
        }
        const x = p1x + t1 * dx1;
        const y = p1y + t1 * dy1;
        return { x, y };
    }
    static getDistance(x1, y1, x2, y2) {
        return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    }
    static getNormal(x1, y1, x2, y2, w, out) {
        if (!out) {
            out = new Vector2();
        }
        let perpx = y2 - y1;
        let perpy = x1 - x2;
        let dist = Math.sqrt(perpx * perpx + perpy * perpy);
        out.x = perpx / dist * w;
        out.y = perpy / dist * w;
        return out;
    }
    static createLineTriangle(path, color, width, loop, outvb, vbstride, outib) {
        var points = path.slice();
        var ptlen = points.length;
        var p1x = points[0], p1y = points[1];
        var p2x = points[2], p2y = points[2];
        var len = 0;
        var rp = 0;
        var dx = 0, dy = 0;
        var pointnum = ptlen / 2;
        if (pointnum <= 1)
            return;
        if (pointnum == 2) {
            return;
        }
        var tmpData = new Array(pointnum * 4);
        var realPtNum = 0;
        var ci = 0;
        for (var i = 0; i < pointnum - 1; i++) {
            p1x = points[ci++], p1y = points[ci++];
            p2x = points[ci++], p2y = points[ci++];
            dx = p2x - p1x, dy = p2y - p1y;
            if (dx != 0 && dy != 0) {
                len = Math.sqrt(dx * dx + dy * dy);
                if (len > 1e-3) {
                    rp = realPtNum * 4;
                    tmpData[rp] = p1x;
                    tmpData[rp + 1] = p1y;
                    tmpData[rp + 2] = dx / len;
                    tmpData[rp + 3] = dy / len;
                    realPtNum++;
                }
            }
        }
        if (loop) {
            p1x = points[ptlen - 2], p1y = points[ptlen - 1];
            p2x = points[0], p2y = points[1];
            dx = p2x - p1x, dy = p2y - p1y;
            if (dx != 0 && dy != 0) {
                len = Math.sqrt(dx * dx + dy * dy);
                if (len > 1e-3) {
                    rp = realPtNum * 4;
                    tmpData[rp] = p1x;
                    tmpData[rp + 1] = p1y;
                    tmpData[rp + 2] = dx / len;
                    tmpData[rp + 3] = dy / len;
                    realPtNum++;
                }
            }
        }
        else {
            rp = realPtNum * 4;
            tmpData[rp] = p1x;
            tmpData[rp + 1] = p1y;
            tmpData[rp + 2] = dx / len;
            tmpData[rp + 3] = dy / len;
            realPtNum++;
        }
        ci = 0;
        for (i = 0; i < pointnum; i++) {
            p1x = points[ci], p1y = points[ci + 1];
            p2x = points[ci + 2], p2y = points[ci + 3];
        }
        if (loop) {
        }
    }
}
